module.exports = __webpack_public_path__ + "img/1.96e3216b.webp";